export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
